import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Product } from '../../../../../admin/src/app/models/product';
import { Faq } from '../../../../../admin/src/app/models/faq';
import { FaqService } from '../../../../../admin/src/app/services/faq.service';
import { Asset } from '../../../../../admin/src/app/models/asset';
import { AuthService } from '../../../../../admin/src/app/services/auth.service';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { LanguageService } from '../../services/language.service';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit, OnDestroy {

  faqId: string;

  faq: Faq;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authSvc: AuthService,
    private faqSvc: FaqService,
    private userSvc: UserService,
    private translate: TranslateService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Faq');

    this.sub = this.route.paramMap.subscribe(params => {
      this.faqId = params.get('id');
      this.getFaq();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getFaq() {
    this.faqSvc.get(this.faqId).subscribe(data => {
      this.faq = Object.assign({}, data.payload);
      this.faq.contents.forEach((content) => {
        let urlRegex = /(http?:\/\/[^\s]+)/g;
        content.text = content.text.replace(urlRegex, function(url) {
          return '<a href="' + url + '" target="blank">' + url + '</a>';
        });
        urlRegex = /(https?:\/\/[^\s]+)/g;
        content.text = content.text.replace(urlRegex, function(url) {
          return '<a href="' + url + '" target="blank">' + url + '</a>';
        });
      });
    });
  }

  localizedFaqAsset(faq: Faq) {
    let lang = this.translate.currentLang;
    let defaultLang = this.translate.defaultLang;
    let content = faq.contents.find(c => c.lang === lang);
    if (!content || !content.asset) {
      content = faq.contents.find(c => c.lang === defaultLang);
    }
    return !!content ? content.asset : {};
  }

  isImage(asset: Asset) {
    return asset.type.indexOf('image') === 0;
  }

  isVideo(asset: Asset) {
    return asset.type.indexOf('video') === 0;
  }

  loadProduct(product: Product) {
    this.router.navigate([product.id], { relativeTo: this.route });
  }

  isUserLoggedIn() {
    return !!this.authSvc.getCurrentToken();
  }

  hasLike(faq: Faq) {
    if (this.isUserLoggedIn()) {
      let user = this.userSvc.getUserInfo();
      return !!user && faq.likes.indexOf(user.id) !== -1;

    } else {
      return false;
    }
  }

  toggleLike(faq: Faq) {
    if (!this.hasLike(faq)) {
      this.faqSvc.addLike(faq.id).subscribe(data => {
        data.payload.contents.forEach((content) => {
          let urlRegex = /(http?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
          urlRegex = /(https?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
        });
        Object.assign(faq, data.payload);
      });
    } else {
      this.faqSvc.deleteLike(faq.id).subscribe(data => {
        data.payload.contents.forEach((content) => {
          let urlRegex = /(http?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
          urlRegex = /(https?:\/\/[^\s]+)/g;
          content.text = content.text.replace(urlRegex, function(url) {
            return '<a href="' + url + '" target="blank">' + url + '</a>';
          });
        });
        Object.assign(faq, data.payload);
      });
    }
  }

}
